import { defineComponent as _defineComponent } from 'vue'
import DefaultNoDataImage from "@/assets/images/no-data.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'LtkListNoData',
  setup(__props) {


return { __sfc: true,DefaultNoDataImage }
}

})